/** @jsx jsx */
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Box, Button, Heading, jsx, Text } from 'theme-ui'
import {
  useAnalytics,
  useTranslate,
} from '@chordcommerce/gatsby-theme-autonomy'
import FormInputWithLabel from '~/components/Generic/Form/InputWithLabel'
import { addUserToKlaviyoList } from '~/services/klaviyo/client'

const FooterNewsletterSignup = () => {
  const translate = useTranslate()
  const { trackEmailCaptured } = useAnalytics()
  const { register, handleSubmit, errors } = useForm()
  const [submitted, setSubmitted] = useState(false)

  const onSubmit = async (data) => {
    const { email } = data

    try {
      addUserToKlaviyoList(
        { $email: email },
        process.env.GATSBY_KLAVIYO_LIST_ID_NEWSLETTER
      )
      trackEmailCaptured({
        emailCapture: {
          email: email,
          page: 'all-pages',
          component: 'footer',
          website: window.location.hostname,
        },
      })
      setSubmitted(true)
    } catch (err) {
      console.error(err, { source: 'FooterNewsletterSignup' })
    }
  }

  return (
    <Box>
      <Heading as="h2" variant="title5" pb={2}>
        {translate('footer.newsletter_signup.title')}
      </Heading>
      {!submitted && (
        <Box as="form" onSubmit={handleSubmit(onSubmit)} sx={{}}>
          <Box mb={2}>
            <FormInputWithLabel
              name="email"
              title={translate('footer.newsletter_signup.input_label')}
              label={translate('footer.newsletter_signup.input_label')}
              placeholder={translate('footer.newsletter_signup.input_label')}
              aria-label={translate('footer.newsletter_signup.input_label')}
              ref={register({
                required: true,
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: translate('validation.invalid_email'),
                },
              })}
            />
          </Box>
          {errors && errors['email'] && (
            <Text as="p" variant="error" mb={2} sx={{ color: 'white' }}>
              {errors['email'].type === 'required' &&
                translate('validation.required_field')}

              {errors['email'].type === 'pattern' &&
                translate('validation.invalid_email')}
            </Text>
          )}
          <Button type="submit" variant="secondaryAlt">
            {translate('footer.newsletter_signup.button')}
          </Button>
        </Box>
      )}

      {submitted && (
        <Text as="p" variant="body2" sx={{ color: 'white' }}>
          {translate('footer.newsletter_signup.confirmation')}
        </Text>
      )}
    </Box>
  )
}

export default FooterNewsletterSignup
